// ======================================================================
// File Name       : EnterpriseSelection
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Modal, Col, Button } from 'react-bootstrap';
import $ from 'jquery';
import TreeView from '../components/Tree';
import { MODAL_SIZE } from '../constants/index';
import { setEnterpriseRelation, convertListToObjectByEnterpriseCd } from '../utils/EnterPriseUtils';

class EnterpriseSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      isNotRefresh: true,
      data: [],
      enterpriseList: [],
      selectedTarget: {},
      currentEnterpriseCd: props.currentEnterpriseCd,
    };
    this.buildTree = this.buildTree.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.enterpriseList) {
      this.setState({
        enterpriseList: nextProps.enterpriseList,
        selectedTarget: nextProps.selectedEnterprise,
      });
      this.buildTree();
    }
  }

  /**
     * Function for building tree
     */
  buildTree() {
    const treeData = this.createTree(this.convertJsonToDataTree(this.state.enterpriseList));
    this.setState({
      data: treeData,
    });
  }

  /**
     * Convert json to tree node
     *
     * @param {array} enterpriseList
     * @returns {array}
     *
     */
  convertJsonToDataTree(enterpriseList) {
    let dataTree = {
      bySecernId: {},
      allSecernIds: [],
    };
    dataTree = enterpriseList.reduce(
      (acc, cur) => {
        const { enterpriseCd, parentEnterpriseInfo } = cur;
        const { parentEnterpriseCd } = parentEnterpriseInfo || {};
        cur.child = (acc.bySecernId[enterpriseCd] || {}).child || [];
        setEnterpriseRelation(acc, enterpriseCd, parentEnterpriseCd);
        return acc;
      },
      {
        bySecernId: convertListToObjectByEnterpriseCd(enterpriseList),
        allSecernIds: [],
      });
    return dataTree;
  }

  /**
   * Build tree
   */
  createTree(enterpriseList) {
    const { bySecernId, allSecernIds, enterpriseCdLogin } = enterpriseList;
    const isDormantState = this.state.isDormantState;
    const buildNodeData = (acc, enterpriseCd) => {
      const enterprise = bySecernId[enterpriseCd];
      if (!enterprise) return acc;
      const { child = [] } = enterprise;
      const children = child.reduce(buildNodeData, []);
      acc.push({
        id: enterpriseCd,
        text: enterprise.enterpriseName,
        icon: false,
        data: { menu: null, callbackData: enterprise },
        children,
        state: {
          selected: enterprise.enterpriseCd === this.state.selectedTarget.enterpriseCd,
        },
      });
      return acc;
    };
    return allSecernIds.reduce(buildNodeData, []);
  }

  /**
     * Handle select node
     *
     * @param {*} event
     * @param {object} node
     */
  handleSelectNode(event, node) {
    if (!node || !node.data || !node.data.callbackData) return;
    this.setState({
      selectedTarget: node.data.callbackData,
    });
  }

  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    const data = this.state.data;
    const treeView = (
      <TreeView
        id="treeEnterprise"
        data={data}
        isNotRefresh={this.state.isNotRefresh}
        onSelectNode={(e, data) => this.handleSelectNode(e, data)}
        ref={(instance) => {
          this.treeInstance = instance;
        }}
        openAll // 20230605_tma
      />
    );
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        size={MODAL_SIZE.lg}
        style={style}
      >
        <Modal.Header onHide={this.props.onCancel} closeButton>
          <Modal.Title className="text-center">
            所属企業を選択してください
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="padding-10">
          <Col sm={12}>
            {treeView}
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Col sm={3} />
          <Col sm={6}>
            <Button variant="default" className="btn-96 margin-10" onClick={this.props.onCancel}>
              キャンセル
            </Button>
            <Button
              variant="primary"
              className="btn-96 margin-10"
              onClick={this.props.onOK.bind(this, this.state.selectedTarget)}
            >
              OK
            </Button>
          </Col>

        </Modal.Footer>
      </Modal>
    );
  }
}

export default EnterpriseSelection;
